if (!customElements.get('smarte-reviews-component')) {
  customElements.define(
    'smarte-reviews-component',
    class SmarteReviewsComponent extends HTMLElement {
      constructor() {
        super();
        this.items = Array.from(this.querySelectorAll('[data-review-item]'));
        this.loadMoreBtn = this.querySelector('[data-load-more]');
        this.loadMoreContainer = this.querySelector('[data-load-more-container]');
        this.sortSelect = this.querySelector('[data-reviews-sort]');
        this.list = this.querySelector('[data-reviews-list]');
        this.perPage = parseInt(this.dataset.perPage || '5', 10);
        this.visibleCount = this.perPage;

        this.init();
      }

      init() {
        if (!this.items.length) return;

        this.updateVisibility();

        if (this.loadMoreBtn) {
          this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
        }

        if (this.sortSelect) {
          this.sortSelect.addEventListener('change', this.handleSort.bind(this));
        }

        // Helpful thumbs voting interaction
        this.querySelectorAll('[data-vote]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const countEl = btn.querySelector('[data-vote-count]');
            if (!countEl) return;
            const current = parseInt(countEl.textContent, 10) || 0;
            countEl.textContent = current + 1;
            btn.disabled = true;
          });
        });
      }

      updateVisibility() {
        this.items.forEach((item, index) => {
          item.style.display = index < this.visibleCount ? '' : 'none';
        });

        if (this.loadMoreContainer) {
          this.loadMoreContainer.style.display = this.visibleCount >= this.items.length ? 'none' : '';
        }
      }

      handleLoadMore() {
        this.visibleCount += this.perPage;
        this.updateVisibility();
      }

      handleSort(e) {
        const criteria = e.target.value;
        const sortedItems = [...this.items];

        if (criteria === 'highest') {
          sortedItems.sort((a, b) => parseInt(b.dataset.stars, 10) - parseInt(a.dataset.stars, 10));
        } else if (criteria === 'lowest') {
          sortedItems.sort((a, b) => parseInt(a.dataset.stars, 10) - parseInt(b.dataset.stars, 10));
        } else if (criteria === 'photos') {
          sortedItems.sort((a, b) => {
            const aHasImg = a.querySelector('.smarte-review-row__media') ? 1 : 0;
            const bHasImg = b.querySelector('.smarte-review-row__media') ? 1 : 0;
            return bHasImg - aHasImg;
          });
        }

        this.items = sortedItems;
        this.items.forEach((item) => this.list.appendChild(item));
        this.visibleCount = this.perPage;
        this.updateVisibility();
      }
    }
  );
}